import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router';

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/Home/index.vue'),
      meta: { title: '病原微生物数据库' }
    },
    {
      path: '/search',
      name: 'Search',
      component: () => import('@/views/Search/index.vue'),
      redirect: '/search/index',
      meta: { title: '物种搜索' },
      children: [
        {
          path: 'index',
          name: 'SearchIndex',
          component: () => import('@/views/Search/views/index.vue'),
          meta: { title: '搜索列表页' }
        },
        {
          path: 'species',
          name: 'SpeciesDetail',
          component: () => import('@/views/Search/views/SpeciesDetail.vue'),
          meta: { title: '分类学详情' }
        },
        {
          path: 'ireceptor',
          name: 'RepertoireDetail',
          component: () => import('@/views/Search/views/RepertoireDetail.vue'),
          meta: { title: '免疫库数据详情' }
        },
        {
          path: 'pathogenic',
          name: 'PathogenicMicrobeDetail',
          component: () => import('@/views/Search/views/PathogenicMicrobeDetail.vue'),
          meta: { title: '病原微生物详情' }
        },
        {
          path: 'genenames',
          name: 'Genenames',
          component: () => import('@/views/Search/views/GenenamesDetail.vue'),
          meta: { title: '基因名详情' }
        }
      ]
    },
    {
      path: '/workflow',
      name: 'Workflow',
      component: () => import('@/views/Workflow/index.vue'),
      meta: { title: '工作流' },
      redirect: '/workflow/index',
      children: [
        {
          path: 'index',
          name: 'WorkflowIndex',
          component: () => import('@/views/Workflow/views/index.vue'),
          meta: { title: '工作流列表页' }
        },
        {
          path: 'detail',
          name: 'WorkflowDetail',
          component: () => import('@/views/Workflow/views/WorkflowDetail.vue'),
          meta: { title: '工作流详情页' }
        }
      ]
    }
  ]
});

export default router;